import React from "react";

const TeamHeader = () => (
  <div className="team-page__hero">
    <h1 className="team-page__title">Team</h1>
    <p className="team-page__subtitle">
      Manage your team members, roles, and credit allocations.
    </p>
  </div>
);

export default TeamHeader;
